import { __require as o } from "./isSymbol.js";
var r, u;
function q() {
  if (u) return r;
  u = 1;
  var n = o();
  function t(i, _, b) {
    for (var m = -1, f = i.length; ++m < f; ) {
      var a = i[m], e = _(a);
      if (e != null && (s === void 0 ? e === e && !n(e) : b(e, s)))
        var s = e, l = a;
    }
    return l;
  }
  return r = t, r;
}
export {
  q as __require
};
